module.exports = __webpack_public_path__ + "static/media/group.8677efc8.svg";